import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'antd';
import React from 'react';

export interface PobDestinationProps {
	pobObj: any;
	showDepartingIcon?: boolean;
}

export function getPobDestinationTooltip(pobObj: any) {
	const destinationName = pobObj?.destinationID?.name;
	if (!destinationName) return undefined;

	return (
		`Passenger ${pobObj.firstName} ${pobObj.lastName} is departing to ` +
		destinationName
	);
}

const PobDestination: React.FC<PobDestinationProps> = (props) => {
	const destinationName = props.pobObj?.destinationID?.name;
	if (!destinationName && !props.showDepartingIcon) return null;

	const destination = (
		<span className='mc-qm-pob-destination'>
			{props.showDepartingIcon ? (
				<FontAwesomeIcon
					className='mc-qm-pob-departing-icon'
					icon={['fas', 'level-up-alt']}
					aria-label='Departing passenger'
				/>
			) : null}
			{destinationName ? (
				<span className='mc-qm-pob-destination-name'>{destinationName}</span>
			) : null}
		</span>
	);

	if (!destinationName) return destination;

	return (
		<Tooltip title={getPobDestinationTooltip(props.pobObj)}>{destination}</Tooltip>
	);
};

export default PobDestination;
